//s_account is localized and defined in s_code.js which is available in global scope
$(function() {
  	'use strict';
  
  	var forms = new forms4i();
  	var initChat =  function() {  
  		var browser = window.navigator.userAgent;
  		//chat not supported in MS IE
  		if(browser.indexOf('MSIE ') > 0 || browser.indexOf('Trident/') > 0 || browser.indexOf('iPhone') > 0 || browser.indexOf('Android ') > 0){
  			return false;
  		}
  	
		$.when(moduleEvents.GetChatCSSBundle()).done(function(data){   
	    	   	var chatWrapper = document.getElementById('chat-wrapper');
	    	   	$(chatWrapper).append(createChatFrame());  	     	   	   
	    	   	//must get latest chat bundle from server
	    	   	$.when(moduleEvents.InitChat()).done(function(result){	
	         		$('#chat-iframe > body').append(result);
	         		window.setTimeout(function(){
	         			var iframe = document.getElementsByTagName('iframe');
	         			if(iframe.length > 0){
		   		  		iframe[0].contentWindow.postMessage(data, '*');	   		  
		   		  		//send user id to update iframe
		   		  		$.when(moduleEvents.GetChatUserID()).done(function(data){
		   		  	 		iframe[0].contentWindow.postMessage(JSON.stringify(data), '*');
		   		  		});
		   		  
		   		  		$.when(moduleEvents.IsOfficeOpen()).done(function(result){
			  	    			if (result.OfficeOpen) {
				      				var chatIcon = document.getElementsByClassName('openChat');
				      				if(chatIcon.length > 0){
				        				chatIcon[0].classList.remove('hide');
				        				chatIcon[0].classList.add('show');
				       			}
			          			}
			      			});
		   	    		}
		   		}, 4000);
	         	});
		});
	};

	var submitEmail = function(el){
  		var email = document.getElementById('email').value;
		var catAlias = document.getElementById('CatalogAlias').value;
		var questions = document.getElementById('questions').value.trim();
		var data = { from: email, questions: questions , catalogAlias: catAlias, emailUS: true };
		if(el.classList.contains('emailYourself')){ 
			data = { from: email, catalogAlias: catAlias, questions: questions , emailUS: false };
		}
		var submitQuestions = ajax({
			url: '/layout/submitquestions',
			method: "POST",
			data: data
		});
		submitQuestions.then(function(response, xhr){
			if (response.success == 'true') {
				if(el.classList.contains('emailYourself')){
					document.getElementById('emailDescription').insertAdjacentHTML('afterend', '<div class="emailSent marginBtm15" role="status"><h3 class="text16 paddingBtm10 textBlue">Thank you!</h3><p>Your email has been sent to ' + email +'</p></div>');
				} else {
					document.getElementById('emailDescription').insertAdjacentHTML('afterend', '<div class="emailSent marginBtm15" role="status"><h3 class="text16 paddingBtm10 textBlue">Thank you!</h3><p>Your email has been received. One of our customer service representatives will respond shortly.</p></div>');
				}
				document.getElementById('email').value = '';
				document.getElementById('questions').value = '';
				document.getElementsByClassName('cancelEmail')[0].focus();
			}
		});
		submitQuestions.catch(function(response, xhr){
			document.getElementById('emailDescription').insertAdjacentHTML('afterend', '<p role="status" class="marginBtm15">Please try again later.</p>');
		});
  	};
  
  	//CANCEL EMAIL
  	var cancelEmail = function () {
		$('#emailPopout').hide('slow', function () {
			$('#emailPopout').detach();
			$('.openEmail').removeClass('bkgdLtGray disabled').addClass('bkgdMdGray');
			$('.openEmail').after('<span class="contactStatus visually-hidden"  role="status">Your email request has been cancelled</span>');
			document.getElementsByClassName("openEmail")[0].focus();
		});
 	 }

	//Create chat window
  	var createChatFrame = function() {
    		var iframe = document.createElement('iframe');
      		setAttributes(iframe, {
        		"id": "chat-iframe",
        		"class": "chat-iframe",
         		"src": "https://chat2.4imprint.com/i3root/examples/EmbeddedWithinOtherPage/chatorcallback.html?chatUsername=ANON_WEB_USER",
         		"title": "4imprint Web Chat",
         		"name": "4imprint Web Chat"
      		});     
    		return iframe;
  	};

	var setAttributes = function(el, attrs) {
    		for (var key in attrs) {
      			el.setAttribute(key, attrs[key]);
    		}
  	};

	//loading chat components takes about 4 seconds. Delay toggle to avoid showing a blank window
  	var enableChatComponents = function(){
    		var iframe = document.getElementById('chat-wrapper');    
    		$('.contactPanel').find('.spinner').detach();
    		$(iframe).toggle('slow');
  	};

	//Has ajax, omniture event handlers 
	var moduleEvents = (function(){
    		var omniture = function () {   
	  		var chatBtnClick = function () {
	    			var account = s_account ? s_account : "4imprintprod";	
	    			var s = s_gi(account);
	    			if (typeof s != "undefined") {
	      				s.linkTrackVars = 'prop28';
             				s.linkTrackEvents = 'None';
	      				s.prop28 = 'Chat Sessions Log'; //Chat traffic, log click event
	      				s.tl(true, 'o', 'Chat Sessions');
           			}
         		};
         
			return {
         			ChatBtnClick: chatBtnClick
			};
   		},
   		getEmailForm = function() {
      			return $.ajax({
      	  			type: "POST",
         			url: '/layout/emailus',
         			dataType: "html",
         			timeout: 15000,
        	 		async: true
       		});
    		},
    		isOfficeOpen = function() {
       		return $.ajax({
         			type: "POST",
         			url: "/Header/IsOfficeOpen",
         			dataType: "json",
         			timeout: 15000,
         			async: true
     	  		});
     		},
     		initChat =  function () {
       		return $.ajax({
         			url: "https://chat2.4imprint.com/i3root/examples/EmbeddedWithinOtherPage/chatorcallback.html?chatUsername=ANON_WEB_USER",
         			type: "GET",
         			dataType: "html",
         			timeout: 15000,
         			async: true       
       		});  	
    		},
    		getChatCSSBundle = function() {
      			return $.ajax({
      	 	 		type: "POST",
         			url: '/layout/getchatcssbundle',
         			dataType: "html",
         			timeout: 15000,
         			async: true
       		});
    		},
    		getChatUserID = function(){
      			return  $.ajax({
         			type: "POST",
         			url: "/Header/GetUserID",
         			dataType: "json",
         			timeout: 15000,
         			success: function (result) {
               			return result;
         			}
     			});
    		};
    
    		return {
			Omniture: omniture,
			GetEmailForm: getEmailForm,
			InitChat : initChat,
			GetChatCSSBundle: getChatCSSBundle,
			IsOfficeOpen: isOfficeOpen,
			GetChatUserID : getChatUserID
		};
	})();
	
	var stickyScroll = function(){
		// make contact panel sticky
		var contactPnl = document.getElementsByClassName('contactPanel')[0];
		var contactTop = contactPnl.offsetTop;
		document.addEventListener("scroll", function() {
	    		var windowTop = window.pageYOffset;
	    		if (contactTop < windowTop) {
	      			contactPnl.classList.remove('absoluteJS');
	      			contactPnl.classList.add('fixedJS');
	    		} else {
	      			contactPnl.classList.remove('fixedJS');
	      			contactPnl.classList.add('absoluteJS');
	    		}
	  	});
	};
	
	initChat();
	stickyScroll();
	
	//Listen to messages from chat window
  	window.addEventListener('message', function(e) {
    		var key = e.message ? "message" : "data";
    		var data = e[key];
    		if(e.data == 'closeChatWindow') {
    			$('#chat-wrapper').toggle('slow');
    			var openChat = document.getElementsByClassName('openChat')[0];
    			openChat.classList.remove('bkgdLtGray');
    			openChat.classList.remove('disabled');
    			openChat.classList.add('bkgdMdGray');
    			openChat.focus();
    			$('.openChat').after('<span class="contactStatus visually-hidden" aria-live="polite">Your chat session has ended.</span>');
    		}
  	}, false);  
  	 
	//Initialize Email Tab
  	//Click handler
  	document.getElementsByClassName('openEmail')[0].addEventListener('click', function(e){
   		if($(this).hasClass('disabled')) return false;
   		if(document.querySelector(".contactStatus")){
   			document.querySelector(".contactStatus").parentNode.removeChild(document.querySelector(".contactStatus"));
   		}
   		$('.contactPanel').append('<div class="spinner" role="alert" aria-busy="true" aria-atomic="true" aria-label="Loading, please wait"><div class="bounce1"></div><div class="bounce2"></div><div class="bounce3"></div></div>');
		$.when(moduleEvents.GetEmailForm()).done(function(result){
			$('.contactPanel').append(result);
			$('.contactPanel').find('.spinner').remove();
			$('#emailPopout').toggle('slow');
			$('.openEmail').removeClass('bkgdMdGray').addClass('bkgdLtGray disabled');
			$('#email').focus();
		});
	});
  	//Keypress handler	
  	document.getElementsByClassName('openEmail')[0].addEventListener('keypress', function(e){
		if(e.which == 13){
 			this.click();
	 	}
  	});
	//Submit Email
  	$('body').on('click touch', '.submitEmail', function (e) {
  		forms.formValidation(document.getElementById("detailsEmail"), submitEmail(this), e);
  	});
  	//Close email popout  
  	$('.contactPanel').on('click', '.cancelEmail', function(e){
  		e.preventDefault();
		cancelEmail();
  	});
  	//Close email popout  	
  	$('.contactPanel').on('keypress', '.cancelEmail', function(e){
		if(e.which == 13){
			$(this).click();
 		}
  	});

	//OPEN CHAT
  	var openChat =  document.getElementsByClassName('openChat');
  	if(openChat.length > 0){
    		openChat[0].addEventListener('click', function(){
     			if(this.classList.contains('disabled')){
   	 			return false;
     			}
     			if(document.querySelector(".contactStatus")){
	   			document.querySelector(".contactStatus").parentNode.removeChild(document.querySelector(".contactStatus"));
	   		}
     			//log click event
     			moduleEvents.Omniture().ChatBtnClick(); 
     			openChat[0].classList.remove('bkgdMdGray');
     			openChat[0].classList.add('disabled');
     			openChat[0].classList.add('bkgdLtGray');
     			this.insertAdjacentHTML('afterend', '<div class="spinner" role="alert" aria-busy="true" aria-atomic="true" aria-label="Loading, please wait while we load chat window"><div class="bounce1"></div><div class="bounce2"></div><div class="bounce3"></div></div>');
     			enableChatComponents();
   		});
   		openChat[0].addEventListener('keypress', function(e){
   			if(e.which == 13){
				this.click();
 			}
     		});
  	}
});